<template>
  <section class="section">
    <div class="container">
      <div class="row" v-if="mode == 'full'">
        <div class="col-m-8">
          <div class="article mb-48">
            <h3>Что мы делаем</h3>
            <p>Give&GO - команда инженеров, разработчиков и дизайнеров с многолетним опытом и высокой экспертизой. Мы помогаем клиентам решать технические задачи любой сложности под ключ, включая разработку программного обеспечения и сборку необходимого оборудования.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-m-4 col-s-6">
          <div class="icon-card">
            <div class="icon-card__icon">
              <SvgIcon name="web" />
            </div>
            <div class="icon-card__title">Веб-сайты</div>
            <div class="icon-card__body">
              Корпоративные сайты, интернет-магазины, Landing page, спецпроекты
            </div>
          </div>
        </div>
        <div class="col-m-4 col-s-6">
          <div class="icon-card">
            <div class="icon-card__icon">
              <SvgIcon name="startup" />
            </div>
            <div class="icon-card__title">Веб-приложения</div>
            <div class="icon-card__body">
              Веб-сервисы со сложной логикой: масштабируемые, стабильные, готовые к нагрузкам и длительной поддержке
            </div>
          </div>
        </div>
        <div class="col-m-4 col-s-6">
          <div class="icon-card">
            <div class="icon-card__icon">
              <SvgIcon name="app" />
            </div>
            <div class="icon-card__title">iOS/Android приложения</div>
            <div class="icon-card__body">
              Легковесные, отзывчивые, удобные приложения для ваших клиентов
            </div>
          </div>
        </div>
        <div class="col-m-4 col-s-6">
          <div class="icon-card">
            <div class="icon-card__icon">
              <SvgIcon name="vr" />
            </div>
            <div class="icon-card__title">AR/VR приложения</div>
            <div class="icon-card__body">
              Качественные туры и интерактивные презентации в AR/VR на базе Unity
            </div>
          </div>
        </div>
        <div class="col-m-4 col-s-6">
          <div class="icon-card">
            <div class="icon-card__icon">
              <SvgIcon name="kiosk" />
            </div>
            <div class="icon-card__title">Интерактивные киоски</div>
            <div class="icon-card__body">
              ПО и оборудование для решения любых задач - презентации, навигация, продажи и интерактивы
            </div>
          </div>
        </div>
        <div class="col-m-4 col-s-6">
          <div class="icon-card">
            <div class="icon-card__icon">
              <SvgIcon name="ai" />
            </div>
            <div class="icon-card__title">Индивидуальное ПО</div>
            <div class="icon-card__body">
              Внутренние сервисы, настольное ПО, парсеры, AI-решения
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mb-30">
        <a class="button" @click.prevent="showModal('5e60b459ad16fa004472f7c5')">Расчет стоимости</a>
      </div>
    </div>
  </section>
</template>
<script>
const name = 'WhatWeDo'
import SvgIcon  from '@/components/SvgIcon.vue'

const props = {
  mode: {
    type: String,
    default: 'full'
  }
}

export default {
  name,
  props,
  components: {
    SvgIcon
  }
}

</script>
